import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Button, Grid } from "@mui/material";

import AlertProtocolTable from "components/pages/alertProtocols/list/table/AlertProtocolTable";
import AccountFilter from "components/common/filters/account/AccountFilter";

import Loading from "components/common/loading/Loading";
import DeviceTypeFilter from "components/common/filters/device_type/DeviceTypeFilter";
import EmptyContainer from "components/common/empty_container/EmptyContainer";
import { useGetAlertProtocolsQuery } from "app/store/alertProtocol/api/alertProtocolApi";
import AlertProtocolModal from "components/pages/alertProtocols/modal/AlertProtocolModal";
import {
  setIsEditModalOpen,
  setIsEditMode,
  setSelectedContent,
  setFilterAccount,
  setFilterDeviceType,
  setAlertProtocols,
} from "app/store/alertProtocol/slice/alertProtocolSlice";
import { showErrorToast } from "utils/toast";

const AlertProtocolList = () => {
  const dispatch = useDispatch();
  const [account, setAccount] = React.useState("");
  const [deviceType, setDeviceType] = React.useState("");

  const {
    isLoading,
    data: alertProtocols,
    error,
  } = useGetAlertProtocolsQuery({
    account,
    deviceType,
  });

  useEffect(() => {
    if (error) {
      showErrorToast(error?.message);
    }
    if (alertProtocols) {
      dispatch(setAlertProtocols(alertProtocols));
    }
  }, [error, alertProtocols, dispatch]);

  const handleAddClick = () => {
    dispatch(setFilterAccount(account));
    dispatch(setFilterDeviceType(deviceType));
    dispatch(setSelectedContent(null));
    dispatch(setIsEditMode(false));
    dispatch(setIsEditModalOpen(true));
  };

  return (
    <>
      <div className="preferences">
        <div className="preferences-container">
          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
            className="preferences-header"
          >
            <Grid item sm={5} container columnSpacing={2}>
              <Grid item xs={6}>
                <AccountFilter
                  displayAll={false}
                  value={account}
                  onChange={(e) => {
                    setAccount(e.target.value);
                    dispatch(setFilterAccount(e.target.value));
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <DeviceTypeFilter
                  displayAll={false}
                  value={deviceType}
                  onChange={(e) => {
                    setDeviceType(e.target.value);
                    dispatch(setFilterDeviceType(e.target.value));
                  }}
                />{" "}
              </Grid>
            </Grid>
            <Grid
              item
              sm={6}
              className="d-flex"
              justifyContent="flex-end"
              spacing={2}
            >
              <Button
                variant="contained"
                color="secondary"
                className="preferences-edit-button"
                onClick={handleAddClick}
                disabled={!account || !deviceType}
              >
                Add
              </Button>
            </Grid>
          </Grid>
          {!account || !deviceType ? (
            <EmptyContainer
              noDataText={
                <div style={{ textAlign: "center" }}>
                  <h3 className="empty__title">Select an account to proceed</h3>
                  <p
                    className="empty__content"
                    style={{
                      margin: "0 auto",
                    }}
                  >
                    Please select an account from the dropdown to configure
                    alert protocol
                  </p>
                </div>
              }
            />
          ) : isLoading ? (
            <Loading />
          ) : (
            <Grid container>
              <Grid item xs={12} style={{ textAlign: "center" }}>
                <AlertProtocolTable alertProtocols={alertProtocols} />
              </Grid>
            </Grid>
          )}
        </div>
      </div>

      <AlertProtocolModal />
    </>
  );
};

export default AlertProtocolList;
